function initCookieAlert() {

	if ( ! $('body').hasClass('is-rgpd-active') ) {
		switch( $('html').attr('lang') ) {

			case "fr-FR":
				cookieText = "<span class='cookie-intro'>On peut parler cookies<br>même dans le fitness</span>Nous diffusons des cookies afin d’analyser le trafic sur ce site. Les informations concernant l’utilisation que vous faites de notre site nous sont transmises dans cette optique.";
				acceptText = "&times;";
				break;

			default:
				cookieText = "<span class='cookie-intro'>We can talk cookies<br>in fitness too</span>We distribute cookies to analyze the traffic on this site. The information concerning the use you make of our site is transmitted to us in this perspective.";
				acceptText = "&times;";
				break;
		}

		$.cookieBar({
			message:       cookieText,
			acceptText:    acceptText,
			declineButton: false,
			expireDays:    30,
			fixed:         true,
			zindex:        10000
		});
	}
}
